import { analytics } from './facade';

export type WhatsNewSurface = 'menu' | 'try' | 'page';

/** What's-new reach: which surface opened the notes, for which release. Safe
 *  to call unconditionally — the facade no-ops until the Statsig client
 *  initializes (only after analytics consent). */
export const ReleaseNotesEvents = {
    opened: (surface: WhatsNewSurface, version: string): void =>
        analytics.track('whats_new_opened', surface, { version }),
};
